import { ReactElement } from "react";

import { Button } from "@chakra-ui/react";

import { RadioOptionType } from "../radio-select-list/types";

type EditableRadioToggleProps<T extends string> = {
  selectedOption?: RadioOptionType<T> | null;
  icon?: ReactElement;
};

export const EditableRadioToggle = <T extends string>({
  selectedOption,
  icon,
  ...props
}: EditableRadioToggleProps<T>) => {
  return (
    <Button
      {...props}
      paddingInline={2}
      paddingBlock={1}
      borderRadius={6}
      size="sm"
      variant="outline"
      justifyContent="flex-start"
      border="none"
      width="100%"
    >
      {icon}
      {selectedOption ? selectedOption.label : "-"}
    </Button>
  );
};
